<div class="card bg-card-new card-radius-06 border-0">
    <app-quotation-history class="p-4"></app-quotation-history>
</div>
